"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lang_1 = require("../lang");
function forEach(obj, cb) {
    if (!(0, lang_1.isObject)(obj)) {
        return;
    }
    const keys = Object.keys(obj);
    keys.forEach((key) => {
        cb(obj[key], key);
    });
}
exports.default = forEach;
